'use client';

import { Box } from '@mui/material';
import Image from 'next/image';
import { usePageAction } from '@repo/hooks/usePageAction';
import { SafeLinkWithFallback } from '../../../../../SafeLinkWithFallback';

type Props = {
  reviewLink?: string;
  source?: string;
  alt?: string;
  institution?: {
    id: string;
    name?: string;
  };
};

export const ProductImage = ({ source, alt, reviewLink, institution }: Props) => {
  const imageClickEvent = usePageAction({
    actionDestinationUrl: reviewLink,
    actionName: 'nw_review_redirected',
    actionSection: 'banking_cd_institution_card',
    actionType: 'select',
    additionalAttributes: {
      institution_id: institution?.id,
      institution_nm: institution?.name,
    },
  });

  if (!source) return null;

  const handleImageOnClick = () => {
    imageClickEvent();
  };
  return (
    <SafeLinkWithFallback href={reviewLink} target="_blank" onClick={handleImageOnClick}>
      <Box
        sx={{
          maxWidth: { xs: '144px', sm: '127px', md: '127px' },
        }}
      >
        <Image
          src={source}
          alt={alt ?? ''}
          width={0}
          height={0}
          sizes="100vw"
          style={{ width: '100%', height: 'auto' }}
        />
      </Box>
    </SafeLinkWithFallback>
  );
};
